<template>
    <div class="mainBody">
        <h2>{{ $t('policyPageTitle') }}</h2>
        <div v-for="element of $t('privacyPolicy')" :key="element">
            <h3 v-html="element.title"></h3>
            <p v-html="element.text"></p>
        </div>
    </div>
</template>

<script>

export default {
    name: 'termsPage',
    components: {
    },
    props: {
        shopData: {},
    },
    data() {
        return {
            activeSheet: 'terms'
        };
    },
    methods: {
        
    },
    created() {
    },
};
</script>

<style>
</style>
<style scoped>
.logoSmall {
    margin-top: -50px;
    width: 250px;
}
h2 {
    margin: 0;
    margin-bottom: 25px;
}
.mainBody {
    padding-top: 100px;
    padding-bottom: 100px;
}
@media(max-width: 1330px) {
    .mainBody {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
    }
}
@media(max-width: 1570px) {
    
    
}
</style>
